import React from "react";

const Logo = () => {
  return <div>
    <h4 className="logo my-4 ">VoiceBooker</h4>
  </div>;
};

export default Logo;
